import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class InverseLabel extends Component {
  static propTypes = {
    color: PropTypes.string,
    children: PropTypes.any,
    className: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
    bold: PropTypes.bool,
    style: PropTypes.any,
  };

  render() {
    const { color, className, children, href, onClick, bold } = this.props;

    return (
      <a
        {...this.props}
        style={{
          color: color,
          padding: '2px 7px',
          border: (bold ? '2px' : '1px') + ' solid ' + color,
          borderRadius: '1000px',
          MozBorderRadius: '1000px',
          WebkitBorderRadius: '1000px',
          fontFamily: 'Lato',
          fontWeight: bold ? '700' : '400',
          ...this.props.style,
        }}
        className={
          'inverse-label ' +
          (className ? className + ' ' : '') +
          (href || onClick ? 'pointer' : '')
        }
      >
        {children}
      </a>
    );
  }
}
